import { graphql, useStaticQuery } from "gatsby";
import React, { Fragment, useEffect, useState } from "react";
import ImageView from "../components/ImageView";
import { animation } from "../utils";
import Footer from "./Footer";
import Header from "./Header";
import ScrollTop from "./ScrollTop";
import LandingHeader from "../components/tailwind/LandingHeader";
import ExitIntentPopup from "../components/ExitIntentPopup";

const Layout = ({ children, header, footer, location }) => {
  //   const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(() => animation());
      } else {
        setTimeout(animation, 200);
      }
    }
  }, []);

  //   useEffect(() => {
  //     const timer = setTimeout(() => setLoader(false), 2000);
  //     return () => clearTimeout(timer);
  //   });
  const { sanitySitesettings, allSanityLandingPage } = useStaticQuery(
    graphql`
      query {
        allSanityLandingPage {
          nodes {
            slug {
              current
            }
          }
        }
        sanitySitesettings {
          topBanner {
            enable
            welcome
            time
            phone
            social {
              icon
              url
            }
          }
          header {
            logo {
              alt
              asset {
                gatsbyImageData(
                  formats: WEBP
                  fit: FILLMAX
                  placeholder: BLURRED
                  width: 160
                )
              }
            }
            logo2 {
              alt
              asset {
                gatsbyImageData(
                  fit: FILLMAX
                  formats: WEBP
                  placeholder: BLURRED
                  width: 100
                )
              }
            }
            button {
              title
              linkType
              link
              btnType
              file {
                asset {
                  url
                }
              }
            }
            menu {
              parent {
                label
                link
                type
              }
              childMenu {
                type
                link
                label
              }
            }
          }
          footer {
            logo {
              alt
              asset {
                gatsbyImageData(fit: FILLMAX, placeholder: DOMINANT_COLOR)
              }
            }
            about
            email
            location
            _rawCc
            serviceAreas {
              title
              links {
                label
                link
                type
              }
            }
            menu {
              label
              link
              type
            }
            newsletter {
              enable
              heading
              button {
                btnType
                link
                linkType
                title
                file {
                  asset {
                    url
                  }
                }
              }
            }
            social {
              icon
              url
            }
          }
          exitIntentPopup {
            enable
            heading
            description
            buttonText
            caption
            successHeading
            successMessage
          }
        }
      }
    `
  );

  // Check if current path matches any landing page slug
  const isLandingPage = allSanityLandingPage.nodes.some((node) => {
    // Need to check for both /slug-name and /slug-name/ formats
    const slugPath = `/${node.slug.current}`;
    return (
      location.pathname === slugPath || location.pathname === `${slugPath}/`
    );
  });

  const [exitIntentEnabled, setExitIntentEnabled] = useState(false);

  // Enable exit intent popup after a short delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setExitIntentEnabled(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Fragment>
      {/* {loader && <PreLoader />} */}
      {/* <VideoPopup /> */}
      <ImageView />
      {!isLandingPage ? (
        <Header
          header={header}
          data={sanitySitesettings.header}
          topBanner={sanitySitesettings.topBanner}
        />
      ) : (
        <LandingHeader data={sanitySitesettings.header} />
      )}
      <div className={!isLandingPage ? "mt-100 mt-md-150 mt-xl-124" : "mt-0"}>
        {children}
      </div>
      {!isLandingPage && (
        <Footer footer={footer} data={sanitySitesettings?.footer} />
      )}

      {exitIntentEnabled && (
        <ExitIntentPopup config={sanitySitesettings.exitIntentPopup} />
      )}
      <ScrollTop />
    </Fragment>
  );
};
export default Layout;
